export interface Category {
  name: string;
  url: string;
  iconClass: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    iconClass: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20arranged%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20luxury%20fashion%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=400&seq=cat-shoes-001&orientation=squarish',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    iconClass: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Folded%20premium%20oversized%20hoodie%20in%20warm%20olive%20green%20color%20on%20clean%20minimal%20cream%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20cozy%20texture%20detail%2C%20high%20quality&width=400&height=400&seq=cat-hoodies-002&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    iconClass: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20premium%20cotton%20t-shirts%20in%20neutral%20earth%20tones%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20minimal%20fashion%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-tshirts-003&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    iconClass: 'ri-cloud-windy-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20designer%20jacket%20in%20warm%20camel%20brown%20color%20displayed%20on%20clean%20minimal%20cream%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20luxury%20outerwear%20detail%2C%20high%20quality&width=400&height=400&seq=cat-jackets-004&orientation=squarish',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    iconClass: 'ri-contrast-2-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20tailored%20trousers%20in%20warm%20taupe%20color%20neatly%20folded%20on%20clean%20minimal%20cream%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20minimal%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-pants-005&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    iconClass: 'ri-bear-smile-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20baseball%20cap%20in%20warm%20beige%20color%20on%20clean%20minimal%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20streetwear%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=400&seq=cat-headwear-006&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    iconClass: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Matching%20athleisure%20tracksuit%20set%20in%20warm%20sage%20green%20color%20on%20clean%20minimal%20cream%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20coordinated%20outfit%2C%20high%20detail&width=400&height=400&seq=cat-sets-007&orientation=squarish',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    iconClass: 'ri-checkbox-blank-circle-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20mens%20boxer%20briefs%20in%20warm%20neutral%20gray%20color%20neatly%20folded%20on%20clean%20minimal%20cream%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20minimal%20aesthetic%2C%20high%20quality%20fabric%20texture&width=400&height=400&seq=cat-underwear-008&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    iconClass: 'ri-shield-star-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sport%20jersey%20in%20vibrant%20warm%20coral%20red%20color%20on%20clean%20minimal%20cream%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20athletic%20wear%20detail%2C%20high%20quality&width=400&height=400&seq=cat-jersey-009&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    iconClass: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20fashion%20accessories%20collection%20including%20sunglasses%20watch%20and%20bracelet%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20luxury%20lifestyle%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-accessories-010&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    iconClass: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20designer%20handbag%20in%20warm%20tan%20leather%20on%20clean%20minimal%20cream%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20luxury%20accessory%20detail%2C%20high%20quality%20craftsmanship&width=400&height=400&seq=cat-bags-011&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    iconClass: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20with%20brass%20buckle%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%2C%20luxury%20accessory%20detail%2C%20high%20quality%20texture&width=400&height=400&seq=cat-belts-012&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    iconClass: 'ri-flask-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20with%20gold%20cap%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%20with%20warm%20glow%2C%20editorial%20luxury%20product%20photography%2C%20fragrance%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-perfumes-013&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    iconClass: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20lifestyle%20products%20including%20wallet%20phone%20case%20and%20small%20gadgets%20on%20clean%20minimal%20warm%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20minimal%20aesthetic%2C%20high%20detail&width=400&height=400&seq=cat-other-014&orientation=squarish',
  },
];